import React, { useState, useEffect } from "react";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core";
import useDebounce from "../../Shared/GeographyFilters/hooks/useDebounce";

const useStyles = makeStyles({
  ToggleButtonGroup: {
    background: "#FFEFF6",
  },
  toggleButton: {
    textTransform: "none",
    color: "rgba(245, 54, 137, .93)",
    padding: "5px 11px 5px 11px",
    backgroundColor: "#FFEFF6",
    fontFamily: "Inter",
    border: "1px solid rgba(243, 179, 207, .6)",
    borderRight: "1px solid rgba(243, 179, 207, .6)",
    marginRight: 1,
    textAlign: "center",
    "&.Mui-selected": {
      backgroundColor: "rgba(243, 179, 207, .6)",
      color: "rgba(245, 54, 137, .93)",
      "&:hover": {
        backgroundColor: "rgba(243, 179, 207, .8)",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(243, 179, 207, .8)",
    },
    "&:first-child": {
      borderRadius: "20px 0px 0px 20px",
    },
    "&:last-child": {
      borderRadius: "0px 20px 20px 0px",
    },
  },
  count: {
    width: "28px",
    height: "20px",
    gap: "8px",
    color: "#E2136E",
    background: "#FFFFFF",
    borderRadius: "10px",
    padding: "2px 6px",
    lineHeight: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "10px",
    fontWeight: "500",
    marginLeft: "6px",
  },
});

const LoadRequestFilter = ({
  activeTab,
  setActiveTab,
  searchTerm,
  setSearchTerm,
  setActionReasonsModalOpen,
  allCount,
  mdoCount,
  omCount,
}) => {
  const config = [
    { title: "All", key: "all", value: allCount },
    { title: "MDO Approval Pending", key: "mdo", value: mdoCount },
    { title: "OM Approval Pending", key: "om", value: omCount },
  ];
  const classes = useStyles();
  const localUserType = JSON.parse(localStorage.getItem("currUserType"));

  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
  const debouncedSearchTerm = useDebounce(localSearchTerm, 400);

  useEffect(() => {
    setSearchTerm(debouncedSearchTerm);
  }, [debouncedSearchTerm, setSearchTerm]);

  const handleSearchChange = (e) => {
    setLocalSearchTerm(e.target.value);
  };

  return (
    <div className="tabs-and-search">
      <ToggleButtonGroup
        value={activeTab.toLowerCase()}
        exclusive
        onChange={(event, newAlignment) => {
          if (newAlignment) setActiveTab(newAlignment);
        }}
        aria-label="text alignment"
      >
        {config.map((item) => (
          <ToggleButton
            value={item.key}
            aria-label="left aligned"
            className={classes.toggleButton}
            key={item.key}
          >
            {activeTab.toLowerCase() === item.key && (
              <AccessTimeIcon style={{ fontSize: 14, marginRight: 5 }} />
            )}
            {item.title} <span className={classes.count}>{item.value}</span>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <div className="right-section">
        {localUserType === "bkash-super-user" && (
          <button
            className="manage-button"
            onClick={() => setActionReasonsModalOpen(true)}
          >
            <span className="manage-button-text">
              Manage Approve/Reject Reasons
            </span>
          </button>
        )}
        <div className="loan-search-bar">
          <SearchIcon
            style={{ color: "#000E3D", height: "20px", width: "20px" }}
          />
          <input
            type="text"
            placeholder="Merchant wallet/ Request ID"
            value={localSearchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadRequestFilter;
